/* globals Option, PropTypes */

import { createRef } from 'react'
import { getUrlParams } from '../../utils'

export default class SelectInput extends React.Component {
  constructor (props) {
    super()
    this.state = {
      options: [],
      loading: !!props.select_options_path
    }
    this.refCurrentSelect = createRef(null)
    this.refCurrentValue = createRef(null)
  }

  static store (name, data) {
    if (_.isUndefined(this.store)) this.store = {}

    if (name && data) {
      const deferred = new $.Deferred()
      if (_.isFunction(data.done)) {
        data.always((result) => {
          deferred.resolve(result || [])
        })
      } else {
        deferred.resolve(data)
      }
      this.store[name] = deferred.promise()
    }
    return this.store[name]
  }

  UNSAFE_componentWillMount () {
    // Get Options
    if (this.props.select_options) { this.setState({ options: this.props.select_options, loading: false }) } else if (this.props.select_options_path) { this._fetchOptions() }
  }

  componentDidMount () {
    const select2Options = {
      placeholder: this.props.placeholder || '',
      allowClear: this.props.allowClear,
      dropdownAutoWidth: this.props.dropdownAutoWidth,
      dropdownCssClass: `${this.props.field}_select2_results`
    }

    if (this.props.allowHtml) {
      const templateFn = (text) => {
        return $(`<span>${text}</span`)
      }

      select2Options.escapeMarkup = text => text
      select2Options.templateResult = templateFn
      select2Options.templateSelection = templateFn
    }

    this.select2 = $(this.refCurrentSelect.current).select2(select2Options).data('select2')

    this.renderLoader()

    $(this.refCurrentSelect.current).on('change change.select2 select2-open select2-close select2-select', (e) => {
      this.select2.container.attr('data-label', e.target.value ? this.props.placeholder || '' : '')
        .toggleClass('show-labelholder', !!e.target.value)
    })

    $(this.refCurrentSelect.current).on('select2-open', () => {
      if (this._isMobileDevice()) {
        setTimeout(() => {
          this.refCurrentSelect.current?.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }, 100)
      }
    })
    $(this.refCurrentSelect.current).on('change', (event) => {
      this.refCurrentValue.current = event.target.value
      // Callback
      if (typeof this.props.onSelect === 'function') this.props.onSelect(event)

      if (this.props.field === 'parent_contact_type') {
        appendChildOptions(event)
      }

      if (this.props.search_form_id && (this.props.name === 'search[unit_id]')) {
        appendDepartmentOptions(event, this.props.search_form_id)
      }
    })
  }

  componentDidUpdate () {
    this.renderLoader()
    $(this.refCurrentSelect.current).trigger('change.select2')

    const parentContactTypeVal = $(this.refCurrentSelect.current).val()
    if (this.props.field === 'parent_contact_type' && parentContactTypeVal) {
      appendChildOptions(parentContactTypeVal)
    }
  }

  render () {
    return (
      <select
        className='labelholder'
        data-label={this.props.placeholder || ''}
        name={this.props.name}
        value={this.refCurrentValue.current || this.props.value || ''}
        onChange={() => { }}
        ref={this.refCurrentSelect}
        id={this.props.field}
        disabled={this.props.disabled}
      >
        <option />

        {
          this.props.optgroups && this.props.optgroups.length
            ? this._renderOptGroups()
            : _.map(this.state.options, (pair, i) => this._renderOption(pair, i))
        }
      </select>
    )
  }

  renderLoader () {
    if (this.state.loading) {
      $(`#s2id_${this.props.field} .select2-choice .select2-chosen`).addClass('ui-autocomplete-loading')
      $(this.refCurrentSelect.current).prop('disabled', true)
    } else {
      $(`#s2id_${this.props.field} .select2-choice .select2-chosen`).removeClass('ui-autocomplete-loading')
      $(this.refCurrentSelect.current).prop('disabled', false)
    }
  }

  _renderOptGroups () {
    return this.props.optgroups.map((group, i) => {
      return (
        <optgroup key={i} label={group[1]}>{
          this.state.options
            .filter((option) => option[2] && option[2] === group[0])
            .map((pair, i) => this._renderOption(pair, i))
        }
        </optgroup>
      )
    })
  }

  _renderOption (pair, i) {
    if (_.isArray(pair) && pair.length > 1) {
      return (
        <option key={i} className={`depth_${pair[2]}`} depth='2' value={pair[1]}>{pair[0]}</option>
      )
    } else {
      console.warn(`Wrong data has been received from /search/fetch_options/${this.props.field}.
                    Expected an array of pairs instead ${typeof pair}.`)
    }
  }

  _fetchOptions () {
    const storedOptions = this.constructor.store(this.props.field)
    const optionsReceived = (data) => {
      this.setState({ options: data || [], loading: false })
    }

    if (storedOptions) {
      storedOptions.done(optionsReceived)
    } else {
      const url = new URL(`${this.props.select_options_path}${this.props.field}`, window.location.origin)
      url.searchParams.set('job_ad_id', this.props.jobAdId)

      this._request = $.ajax({
        url,
        method: 'GET'
      })
      this.constructor.store(this.props.field, this._request)
      this._request.done(optionsReceived)
    }
  }

  componentWillUnmount () {
    if (this._request) this._request.abort()
  }

  _isMobileDevice () {
    if (typeof window === 'undefined') return false
    return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) || window.innerWidth <= 768
  }
}

function appendChildOptions (e) {
  const input = $('#child_contact_type_input')
  const select = $('#child_contact_type')
  const prompt = '<option value=""></option>'
  const value = (e && e?.target) ? e.val : e

  select.empty()
  select.prepend(prompt)

  if (value) {
    $.ajax({
      url: `/search/fetch_options/child_contact_type?parent_contact_type=${value}`,
      type: 'GET',
      success: (response) => {
        if (response.length > 0) {
          $.each(response, function (_, item) {
            select.append(new Option(item[0], item[1], false, false))
          })
          const value = getUrlParams(['search[child_contact_type]'])['search[child_contact_type]']
          select.val(value).trigger('change')
          input.slideDown()
        } else {
          select.val(null).trigger('change')
          input.slideUp()
        }
      }
    })
  } else {
    select.val(null).trigger('change')
    input.slideUp()
  }
}

function appendDepartmentOptions (e, searchFormId) {
  const UnitId = e.val || 0
  const select = $(`#${searchFormId} #department`)

  select.select2('val', '')
  select.empty()

  $.ajax({
    url: `/units/${UnitId}/departments/active`,
    type: 'GET',
    dataType: 'json',
    success: (response) => {
      if (response.length > 0) {
        $.each(response, function (_, item) {
          const option = new Option(item.name, (item.id || item.department_id))

          option.setAttribute('class', `depth_${item.depth}`)
          select.append(option)
        })
        select.val(null).trigger('change')
      } else {
        select.val(null).trigger('change')
      }
    }
  })
}

SelectInput.propTypes = {
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  field: PropTypes.string.isRequired,
  value: PropTypes.string,
  select_options: PropTypes.arrayOf(PropTypes.array), // [[text, value, *type], [text, value, *type]]
  select_options_path: PropTypes.string, // select2 adapter
  onSelect: PropTypes.func,
  allowClear: PropTypes.bool,
  dropdownAutoWidth: PropTypes.bool,
  allowHtml: PropTypes.bool,
  onClear: PropTypes.func,
  disabled: PropTypes.bool,
  optgroups: PropTypes.arrayOf(PropTypes.array) // [[type_key, type_label], [type_key, type_label]]
}
